import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap'
import Card from '../Card'
import { apiHandler } from '../../api/apihandler';
import { UPDATE_PHOTOGRAPH_USE } from "../../api/constants";
import Swal from 'sweetalert2'

// Redux Selector / Action
import { useDispatch, useSelector } from 'react-redux';
import { setUserData } from '../../store/setting/actions'

const PictureApproval = () => {
    const dispatch = useDispatch()
    let profileData = useSelector((state) => state.setting.setting.user_data)
    profileData = profileData ? JSON.parse(profileData) : null;

    const [photographUse, setPhotographUse] = useState(() => {
        // Initialize state from profileData on first render only
        return profileData?.user_setting?.is_student_photograph_use === 1;
    });
    const [isLoading, setIsLoading] = useState(false);

    const handleToggle = async () => {
        const newValue = !photographUse;
        const apiValue = newValue ? 1 : 0;
        
        // Optimistically update UI
        setPhotographUse(newValue);
        setIsLoading(true);

        try {
            const res = await apiHandler(UPDATE_PHOTOGRAPH_USE, "POST", {
                is_student_photograph_use: apiValue
            });

            if (res.data?.response?.status === 200) {
                // Update Redux store with the complete user data from API response
                const userData = res.data?.data?.data;
                if (userData) {
                    dispatch(setUserData(JSON.stringify(userData)));
                }

                // Show success message
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: res.data?.data?.message || 'Picture approval setting updated successfully.',
                    timer: 2000,
                    showConfirmButton: false
                });
            } else {
                // Revert on error
                setPhotographUse(!newValue);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: res.data?.data?.message || 'Failed to update photograph approval setting.',
                });
            }
        } catch (error) {
            // Revert on error
            setPhotographUse(!newValue);
            console.error('Error updating photograph approval:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occurred while updating the setting.',
            });
        } finally {
            setIsLoading(false);
        }
    };

    // Only show for students with specific conditions
    // Hide for admin (user_type === 4) and teacher (user_type === 2)
    // Hide if CLASS_AVAILABLE is not enabled
    // Hide if user is influencer or dance_corner
    if (!profileData || 
        profileData.user_type === 4 || 
        profileData.user_type === 2 ||
        (process.env.REACT_APP_IS_CLASS_AVAILABLE !== 1 && process.env.REACT_APP_IS_CLASS_AVAILABLE !== "1") ||
        profileData?.user_setting?.is_influencer !== 0 || 
        profileData?.user_setting?.is_dance_corner !== 0) {
        return null;
    }

    return (
        <Card>
            <Card.Body>
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <h5 className="mb-1">Picture Approval</h5>
                        <p className="mb-0 text-muted" style={{ fontSize: '14px' }}>
                            Allow your photos to be used in posts and activities
                        </p>
                    </div>
                    <Form.Check
                        type="switch"
                        id="picture-approval-switch"
                        checked={photographUse}
                        onChange={handleToggle}
                        disabled={isLoading}
                        style={{ transform: 'scale(1.3)' }}
                    />
                </div>
            </Card.Body>
        </Card>
    );
};

export default PictureApproval;
